import React, { useEffect, useState } from 'react'
import pageLoading from '../utils/pageLoading'

const TopLoadingBar = () => {
    const [status, setStatus] = useState('hidden')

    useEffect(() => pageLoading.subscribe(setStatus), [])

    return (
        <div
            className={`hdv-top-loading${status !== 'hidden' ? ` is-visible is-${status}` : ''}`}
            aria-hidden="true"
        >
            <div className="hdv-top-loading__bar" />
        </div>
    )
}

export default TopLoadingBar
